var KEYS = [0xA3B1C5D7, 0x7E2F4C98, 0x1D5F3A9E];
var OFFSET = 314159;

var PERM = [
  23, 5, 17, 31, 8, 14, 26, 2,
  19, 11, 28, 0, 15, 7, 21, 3,
  30, 9, 24, 13, 1, 18, 6, 29,
  10, 22, 4, 16, 27, 12, 20, 25,
];

var INV_PERM = [
  11, 20, 7, 15, 26, 1, 22, 13,
  4, 17, 24, 9, 29, 19, 5, 12,
  27, 2, 21, 8, 30, 14, 25, 0,
  18, 31, 6, 28, 10, 23, 16, 3,
];

var shuffleBits = function (n, perm) {
  var result = 0;
  for (var i = 0; i < 32; i++) {
    if (n & (1 << i)) {
      result |= 1 << perm[i];
    }
  }
  return result >>> 0;
};

export var encodeClubID = function (clubID) {
  var v = (clubID + OFFSET) >>> 0;
  for (var r = 0; r < KEYS.length; r++) {
    v = (v ^ KEYS[r]) >>> 0;
    v = shuffleBits(v, PERM);
  }
  return v.toString(36);
};

export var decodeClubID = function (encoded) {
  var v = parseInt(encoded, 36) >>> 0;
  for (var r = KEYS.length - 1; r >= 0; r--) {
    v = shuffleBits(v, INV_PERM);
    v = (v ^ KEYS[r]) >>> 0;
  }
  return v - OFFSET;
};
